module.exports = __webpack_public_path__ + "static/media/Olympus2.01fbfdb1.png";